'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatLegroomExtra = function MdAirlineSeatLegroomExtra(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38 28.8q0.6 0.9 0.2 1.9t-1.3 1.5l-6.2 2.8-5.7-11.6h-11.6q-2.1 0-3.6-1.5t-1.4-3.5v-13.4h10v10h5.8q2.1 0 3 1.9l5.6 11.6 1.9-0.8q0.9-0.4 1.9-0.1t1.4 1.2z m-31.4-8.8q0 2 1.5 3.5t3.5 1.5h10v3.4h-10q-3.4 0-5.8-2.5t-2.4-5.9v-15h3.2v15z' })
        )
    );
};

exports.default = MdAirlineSeatLegroomExtra;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-legroom-extra.js
// module id = 2040
// module chunks = 0